import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { DropDownBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { phoneTypes } from '../../../../../common/SharedConstants';

export const PhoneNumberATypeField = () => {
    const value = useBrokerDetailsStore((s) => s.phoneNumberAType);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);
    const changed = useBrokerFieldFieldChanged(FormField.PhoneNumberAType);
    return (
        <>
            <DropDownBox
                id='cPhoneNumberAType'
                value={value}
                onChange={(v) => updateFields({ phoneNumberAType: v })}
                label='Type'
                width={'100%'}
                required={isBroker}
                dataSource={phoneTypes}
                placeholder='Select'
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon={'asterisk'}
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
